import { render, staticRenderFns } from "./HistoryCompanies.vue?vue&type=template&id=6e4b14da&scoped=true"
import script from "./HistoryCompanies.vue?vue&type=script&lang=js"
export * from "./HistoryCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4b14da",
  null
  
)

export default component.exports